import { Select, SelectItem, SelectSkeleton } from "carbon-components-react"
import React, { useContext, useEffect, useRef, useState } from "react"
import _ from "lodash"
import { getLanguages } from "api/functions/functions"
import MainContext from "context/MainContext"

const LanguageSelector = (props) => {

    const [languages, setLanguages] = useState([])

    const context = useContext(MainContext)
    const select = useRef()

    useEffect(() => {
        fetchData()
        return () => {
            setLanguages([])
        }
    }, [])

    useEffect(() => {
        if (props.onLanguagesLoaded) {
            props.onLanguagesLoaded(languages)
        }
    }, [languages])

    const fetchData = async () => {
        let langs = []

        const filter = context.evt?.languages ? context.evt.languages : null

        const data = await getLanguages();
        langs = filter ? data.filter(l => {
            return filter.includes(l.id)
        }) : data

        setLanguages(langs)

        let defaultLanguage = null
        if (context.evt?.default_language) {
            defaultLanguage = context.evt.default_language
        }
        else {
            defaultLanguage = "en"
        }

        let defaultPosition = 0
        langs.forEach((element, index) => {
            if (element.id === defaultLanguage) {
                defaultPosition = index
            }
        });


        if(select?.current?.options){
            select.current.options[defaultPosition].selected = true;
        }

    }

    return (
        <div style={{ marginBottom: "2rem", position: "relative" }}>
            <Select
                labelText="Language"
                value={props.selectedLangCode}
                onChange={(e) => props.onChange(e)}
                ref={select}
            >
                {
                    !_.isEmpty(languages) ? languages.map((item, index) => {
                        return (
                            <SelectItem text={item.label} value={item.id} key={`language-item-${index}`} />
                        )
                    }) : (
                        <SelectSkeleton />
                    )
                }
            </Select>
        </div>
    )
}

export default LanguageSelector